import client from "./axios";

// Instagram Partnership Ads via the Meta Marketing API, proxied through our backend.
const ENV = `${process.env.REACT_APP_BACKEND_URL}/ads`;

/** Discover business / ad accounts / page / IG identities from the stored token. */
export const getAdsDiscovery = async () => {
  const response = await client.get(`${ENV}/discovery`);
  return response.data;
};

/** Validate a creator post's eligibility (carousel card limit, etc.). */
export const validateAdMedia = async (
  creatorMediaId: string,
  hasCta = false,
) => {
  const response = await client.post(`${ENV}/validate-media`, {
    creatorMediaId,
    hasCta,
  });
  return response.data;
};

export interface PartnershipAdPayload {
  creatorMediaId: string;
  creatorUsername?: string;
  name?: string;
  objective?: string;
  dailyBudget?: number; // minor units (cents)
  optimizationGoal?: string;
  billingEvent?: string;
  countries?: string[];
  cta?: { type: string; link?: string } | null;
  dryRun?: boolean;
}

/** Create the full (PAUSED) partnership ad for a creator post. */
export const createPartnershipAd = async (payload: PartnershipAdPayload) => {
  const response = await client.post(`${ENV}/partnership`, payload);
  return response.data;
};

/** List the user's partnership ads. */
export const listPartnershipAds = async () => {
  const response = await client.get(ENV);
  return response.data;
};

/** Live campaign -> ad set -> ad -> creative tree from Meta. */
export const getAdsCampaignsLive = async (all = false) => {
  const response = await client.get(`${ENV}/campaigns/live`, {
    params: all ? { all: "true" } : {},
  });
  return response.data;
};

/** Activate campaign + ad set + ad (all three). */
export const goLivePartnershipAd = async (id: string) => {
  const response = await client.post(`${ENV}/${id}/go-live`);
  return response.data;
};

/** Pause / archive / re-activate (campaign cascades). */
export const setPartnershipAdStatus = async (id: string, status: string) => {
  const response = await client.post(`${ENV}/${id}/status`, { status });
  return response.data;
};

/** Live effective_status from Meta. */
export const getPartnershipAdStatus = async (id: string) => {
  const response = await client.get(`${ENV}/${id}/status`);
  return response.data;
};

/** Permanently delete (campaign + everything beneath it). Irreversible. */
export const deletePartnershipAd = async (id: string) => {
  const response = await client.delete(`${ENV}/${id}`);
  return response.data;
};
